import { DownloadTextFile } from "./utils";
import { getExportText } from "./exportI18n";

const joinLines = (lines = []) => lines.filter(Boolean).join("\n");

const getPromptDebugRequest = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.__LAST_GPT_ANALYSIS_REQUEST__ || null;
};

const buildPromptMetadataLines = ({ filters, language, reportName, requestDebug, t }) => {
  const overlays = requestDebug?.validation?.promptOverlays || [];

  return [
    getExportText(t, language, "reports.promptExportTitle", "البرومبت المرسل إلى الذكاء الاصطناعي", "AI Prompt Export"),
    "",
    `${getExportText(t, language, "reports.report", "التقرير", "Report")}: ${reportName || "-"}`,
    `${getExportText(t, language, "reports.period", "الفترة", "Period")}: ${filters?.period || "-"}`,
    `${getExportText(t, language, "reports.language", "اللغة", "Language")}: ${language === "en" ? "English" : "العربية"}`,
    `${getExportText(t, language, "reports.exportedAt", "وقت التصدير", "Exported At")}: ${new Date().toLocaleString(language === "en" ? "en-US" : "ar-EG")}`,
    `${getExportText(t, language, "reports.promptMode", "وضع البرومبت", "Prompt Mode")}: ${requestDebug?.validation?.promptMode || "-"}`,
    `${getExportText(
      t,
      language,
      "reports.promptOverlays",
      "الطبقات المضافة",
      "Prompt Overlays"
    )}: ${overlays.length ? overlays.join(", ") : "-"}`,
    `${getExportText(
      t,
      language,
      "reports.assistantProfile",
      "ملف المساعد",
      "Assistant Profile"
    )}: ${requestDebug?.validation?.assistantProfile || "-"}`,
    `${getExportText(t, language, "reports.promptLength", "طول البرومبت", "Prompt Length")}: ${requestDebug?.promptLength || 0}`,
  ];
};

export const buildPromptTextExport = ({ filters, language, reportName, requestDebug, t }) => {
  const prompt = requestDebug?.prompt || requestDebug?.userMessageBody?.content || "";

  if (!prompt.trim()) {
    throw new Error(
      getExportText(
        t,
        language,
        "reports.promptUnavailable",
        "لا يوجد برومبت محفوظ حاليًا لهذا التحليل.",
        "No saved prompt is available for this analysis."
      )
    );
  }

  return joinLines([
    ...buildPromptMetadataLines({ filters, language, reportName, requestDebug, t }),
    "",
    "==================================================",
    getExportText(t, language, "reports.promptBody", "نص البرومبت", "Prompt Body"),
    "==================================================",
    "",
    prompt,
  ]);
};

export const exportPromptToText = ({ filename, filters, language, reportName, t }) => {
  const requestDebug = getPromptDebugRequest();
  const content = buildPromptTextExport({
    filters,
    language,
    reportName,
    requestDebug,
    t,
  });

  DownloadTextFile(content, filename);
};
